<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm
                :default-values="{}"
                create
                title="Create Game Type"
                @finish="handleItemsUpdate"
            >
              <template #button="{onclick}">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
            </EditForm>
          </div>
        </div>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="scroll-wrapper">
                <div class="scroll">
                </div>
              </div>
              <div class="table-wrapper mb-10">
                <b-table
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :empty-text="emptyText"
                    show-empty
                    :busy="!!cancel"
                    :items="items"
                    :fields="fields"
                    :no-local-sorting="true"
                    :sort-icon-left="true"
                >
                  <template #cell(actions)="row">
                    <EditForm
                        :default-values="{...row.item}"
                        title="Edit Game Type"
                        @finish="handleItemsUpdate"
                    />
                    <RemoveForm :object="row.item.id"
                                message="Please confirm removing game type"
                                :url="'/api/v1/game-types/' + row.item.id"
                                @finish="handleItemsUpdate"
                    />
                  </template>
                </b-table>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import EditForm from "../../components/GameType/EditGameTypeForm";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import axios from "axios";
import {getRouteIcon, ROUTE_CONFIGS} from "../../utils/routerIcons";


export default {
  components: {
    RemoveForm,
    EditForm
  },
  data() {
    return {
      cancel: null,
      error: null,
      items: [],
      fields: [
        { key: 'id', label: 'ID'},
        { key: 'name', label: 'Name'},
        { key: 'actions', label: 'Actions', }
      ],
      filters: {},
    }
  },
  computed: {
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_CONFIGS),
  },
  methods: {
    handleItemsUpdate() {
      this.loadItems();
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      let self = this;
      loadingInstance.show();

      this
          .$http({
            url: '/api/v1/game-types',
            method: 'GET',
            cancelToken: new axios.CancelToken(c => {self.cancel = c})
          })
          .then(resp => {
            this.items = resp.data;
          })
          .catch((err) => {
            this.items = [];
            this.error = err;
          })
          .finally(() => {
            loadingInstance.close();
            this.cancel = null;
          });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>
